import {
  AtlasBodySubtitle,
  BottomGroupMolecule,
  ConfirmationDialogMolecule,
  PageContentAtom,
  PrimaryButtonAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'
import LoaderAtom from 'components/atoms/Loader.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { InstructionsMolecule } from 'components/molecule/Instructions.molecule'
import { ListMolecule } from 'components/molecule/List.molecule'
import { ScannerMolecule } from 'components/molecule/Scanner.molecule'
import { ModalOrganism } from 'components/organisms/Modal.organism'
import { SearchPalletsOrganism } from 'components/organisms/SearchPalletsOrganism'
import { ShipmentPalletsOrganism } from 'components/organisms/ShipmentPallets.organism'
import { TransferProgressCard } from 'components/organisms/TransferProgressCard.organism'
import { usePreparation } from './Preparation.hook'

const PreparationPage = () => {
  const {
    actions,
    docNum,
    palletsData,
    atLeastOnePalletScanned,
    dialogRef,
    scannedPallets,
    isModalOpen,
    filteredPallets,
    loading
  } = usePreparation()

  return (
    <>
      {loading && <LoaderAtom>Cargando</LoaderAtom>}

      <ToolbarMolecule
        title="Preparación"
        actionIcon="ic_arrow_back"
        onAction={actions.onGoBack}
      />
      {isModalOpen && (
        <ModalOrganism
          title="Buscar Tarima"
          actionIcon="ic_arrow_back"
          onAction={actions.onCloseModal}
          onSearch={actions.filterPallets}
        >
          <SearchPalletsOrganism pallets={filteredPallets} />
        </ModalOrganism>
      )}

      <PageContentAtom style={{ paddingBottom: '75px' }}>
        <StackAtom $direction="column" $gap={25}>
          <TransferProgressCard
            docNum={docNum}
            palletsLabel={`${scannedPallets.length}/${Object.values(palletsData).length}`}
          />

          <InstructionsMolecule
            lines={['Escanea la etiqueta de la tarima.']}
            iconName="ic_search"
            onClickIcon={actions.openSearchModal}
          />

          <ShipmentPalletsOrganism pallets={Object.values(palletsData)} />
        </StackAtom>

        <BottomGroupMolecule bgColor="#212121">
          <PrimaryButtonAtom
            type="button"
            disabled={!atLeastOnePalletScanned}
            onClick={actions.onContinue}
          >
            Continuar
          </PrimaryButtonAtom>
        </BottomGroupMolecule>
        <ScannerMolecule mode="hidden" onScan={actions.onScanPallet} />

        <ConfirmationDialogMolecule
          dialogRef={dialogRef}
          confirmText="Confirmar"
          cancelText="Cancelar"
          onConfirm={actions.onConfirmPallets}
        >
          <StackAtom $direction="column" $gap={24}>
            <AtlasBodySubtitle>
              Despacharás las siguientes tarimas de la {docNum}:
            </AtlasBodySubtitle>
            <ListMolecule lines={scannedPallets} />
          </StackAtom>
        </ConfirmationDialogMolecule>
      </PageContentAtom>
    </>
  )
}

export default PreparationPage
